// src/services/api/market.js
// Market orders, offers, quotes, deals, and auction functions.

import { fetchWithCommonHeaders, API_URL } from './helpers';

export const FetchOfferDetail = async (token, itemCode) => {
    const url = `${API_URL}v2/market/offers/details`;

    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
        body: { itemCode }
    });

    if (!response.ok) {
        throw new Error("Failed to fetch item data: " + response.statusText);
    }

    return response.json();
};

export const SendMarketOrder = async (token, itemCode, orderType, price, qty) => {
    const url = `${API_URL}v2/market/order/create`;

    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
        body: { itemCode, orderType, price, qty }
    });

    if (!response.ok) {
        let errorResult = "error";
        try {
            const data = await response.json();
            if (data && data.result) {
                errorResult = data.result;
            }
        } catch (e) {}
        const err = new Error(errorResult);
        err.response = response;
        err.result = errorResult;
        throw err;
    }

    return response.json();
};

export const CancelMarketOrder = async (token, mode, offerId) => {
    const url = `${API_URL}v2/market/order/cancel`;

    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
        body: { mode, offerId }
    });

    if (!response.ok) {
        let errorResult = "error";
        try {
            const data = await response.json();
            if (data && data.result) {
                errorResult = data.result;
            }
        } catch (e) {}
        const err = new Error(errorResult);
        err.response = response;
        err.result = errorResult;
        throw err;
    }

    return response.json();
};

export const fetchActiveLoads = async (token) => {
    const url = `${API_URL}v2/auction/lots`;

    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
    });

    if (!response.ok) {
        throw new Error("Failed to fetch active loads: " + response.statusText);
    }

    return response.json();
};

export const fetchActiveOffers = async (token) => {
    const url = `${API_URL}v2/market/offers`;

    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
    });

    if (!response.ok) {
        throw new Error("Failed to fetch active loads: " + response.statusText);
    }

    return response.json();
};

export const fetchUserDeals = async (token) => {
    const url = `${API_URL}v2/market/deals`;

    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
    });

    if (!response.ok) {
        throw new Error("Failed to fetch active loads: " + response.statusText);
    }

    return response.json();
};

export const fetchQuotes = async (token) => {
    const url = `${API_URL}v2/market/quotes`;

    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
    });

    if (!response.ok) {
        throw new Error("Failed to fetch active loads: " + response.statusText);
    }

    return response.json();
};

export const fetchAuctionLot = async (token, lotId) => {
    const url = `${API_URL}v2/auction/lot`;

    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
        body: { lotId: lotId },
    });

    if (!response.ok) {
        let errorResult = "error";
        try {
            const data = await response.json();
            if (data && data.result) {
                errorResult = data.result;
            }
        } catch (e) {}
        const err = new Error(errorResult);
        err.response = response;
        err.result = errorResult;
        throw err;
    }

    return response.json();
};
